import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="contact-page">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-medium tracking-tight font-serif hover:text-accent transition-colors">
            Decided
          </Link>
          <Link to="/login">
            <Button variant="ghost" size="sm">
              Log in
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <h1 className="text-3xl md:text-4xl font-medium tracking-tight font-serif text-foreground">
          Contact
        </h1>

        <div className="mt-12 space-y-8 text-muted-foreground leading-relaxed">
          <p className="text-foreground text-lg">
            Need help or have a question?<br />
            Email us at{' '}
            <a 
              href="mailto:hello@usedecided.com" 
              className="text-foreground underline underline-offset-4 hover:text-accent transition-colors"
            >
              hello@usedecided.com
            </a>
          </p>

          <p>
            We reply within 1–2 business days.
          </p>

          <div>
            <p className="mb-3">When contacting us, please include:</p>
            <ul className="list-disc list-inside space-y-1 ml-1">
              <li>the email associated with your account</li>
              <li>a short description of the issue or question</li>
            </ul>
          </div>

          <p>
            Privacy or data requests can also be sent to{' '}
            <a 
              href="mailto:hello@usedecided.com" 
              className="text-foreground underline underline-offset-4 hover:text-accent transition-colors"
            >
              hello@usedecided.com
            </a>
            .
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link>
            <Link to="/why" className="hover:text-foreground transition-colors">Why Decided</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
            <Link to="/login" className="hover:text-foreground transition-colors">Login</Link>
          </div>
          <p className="mt-6 text-center text-xs text-muted-foreground/50">
            © {new Date().getFullYear()} Decided
          </p>
        </div>
      </footer>
    </div>
  );
}
